/**
 * Widget registry.
 * Maps WIDGET_IDS to their React components.
 * The DynamicDashboard renders widgets by looking them up here.
 */

import React, { Suspense } from 'react';

// Lazy-load each widget to keep the initial bundle small.
const RevenueWidget    = React.lazy(() => import('./RevenueWidget'));
const ProfitWidget     = React.lazy(() => import('./ProfitWidget'));
const SalesTodayWidget = React.lazy(() => import('./SalesTodayWidget'));
const OrdersWidget     = React.lazy(() => import('./OrdersWidget'));
const InventoryWidget  = React.lazy(() => import('./InventoryWidget'));
const LowStockWidget   = React.lazy(() => import('./LowStockWidget'));
const AIInsightsWidget = React.lazy(() => import('./AIInsightsWidget'));
const ForecastWidget   = React.lazy(() => import('./ForecastWidget'));
const POSQuickWidget   = React.lazy(() => import('./POSQuickWidget'));
const PaymentsWidget   = React.lazy(() => import('./PaymentsWidget'));
const ExpensesWidget   = React.lazy(() => import('./ExpensesWidget'));
const BookingsWidget   = React.lazy(() => import('./BookingsWidget'));
const DueReturnsWidget = React.lazy(() => import('./DueReturnsWidget'));
const AlertsWidget     = React.lazy(() => import('./AlertsWidget'));
const CampaignsWidget  = React.lazy(() => import('./CampaignsWidget'));

export const WIDGET_REGISTRY = {
  RevenueWidget,
  ProfitWidget,
  SalesTodayWidget,
  OrdersWidget,
  InventoryWidget,
  LowStockWidget,
  AIInsightsWidget,
  ForecastWidget,
  POSQuickWidget,
  PaymentsWidget,
  ExpensesWidget,
  BookingsWidget,
  DueReturnsWidget,
  AlertsWidget,
  CampaignsWidget,
};

const WidgetSkeleton = () => (
  <div className="widget-skeleton" style={{
    height: 160,
    borderRadius: 16,
    background: 'linear-gradient(90deg, #f0f2f5 25%, #e8eaed 50%, #f0f2f5 75%)',
    backgroundSize: '200% 100%',
    animation: 'shimmer 1.4s infinite',
  }} />
);

/**
 * Render a widget by its ID string.
 * Returns null if the widget is not in the registry.
 */
export function renderWidget(widgetId, props = {}) {
  const Component = WIDGET_REGISTRY[widgetId];
  if (!Component) return null;
  return (
    <Suspense key={widgetId} fallback={<WidgetSkeleton />}>
      <Component {...props} />
    </Suspense>
  );
}
